import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { SaisinesContainer } from './saisines.container';
import {
  autofillApply,
  autofillPreview,
  clearAutofill,
  clearEligibleClaims,
  createSaisine,
  dismissSaisineFlag,
  retrieveSaisines,
  searchEligibleClaims,
} from '../../usecases/saisine.actions';
import {
  selectAutofill,
  selectAutofillLoading,
  selectEligibleClaims,
  selectEligibleLoading,
  selectSaisineErrors,
  selectSaisineListLoading,
  selectSaisines,
  selectSaisinesTotal,
} from '../../usecases/saisine.selector';

const mapStateToProps = (state) => ({
  search: state.router.location.search,
  saisines: selectSaisines(state),
  total: selectSaisinesTotal(state),
  loadingList: selectSaisineListLoading(state),
  errors: selectSaisineErrors(state),
  eligibleClaims: selectEligibleClaims(state),
  eligibleLoading: selectEligibleLoading(state),
  autofill: selectAutofill(state),
  autofillLoading: selectAutofillLoading(state),
});

const mapDispatchToProps = (dispatch) => ({
  push: (value) => dispatch(push(value)),
  retrieveSaisines: (search) => dispatch(retrieveSaisines(search)),
  createSaisine: (claimIds) => dispatch(createSaisine(claimIds)),
  searchEligibleClaims: (saisineId, text) => dispatch(searchEligibleClaims(saisineId, text)),
  clearEligibleClaims: () => dispatch(clearEligibleClaims()),
  runAutofillPreview: () => dispatch(autofillPreview()),
  runAutofillApply: (proposal) => dispatch(autofillApply(proposal)),
  clearAutofill: () => dispatch(clearAutofill()),
  dismissFlag: () => dispatch(dismissSaisineFlag()),
});

const Saisines = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SaisinesContainer);

export default Saisines;
